import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getSettings({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.saving_selected_area.list'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async update({ commit }, payload) {
    return await apiService.post(route('member.fcs.saving_selected_area.update'), payload)
  },
}

export default {
  state,
  mutations,
  actions,
}
